import {xeroApi} from './Api'

export const OrderConstant = {
    MaxImageUploadCountPerProduct: 3,
    MaxTotalImageSize: 10485760, //10MB, in Bytes
    MaxSizePerImage: 2097152,
    MaxProductAllowed: 10,

    MaxOrderRequestLimit: 100,
    RowsPerPage: [25, 50, 100],
}

export const LocalStorageConstant = {
    JwtKey: 'token'
}

export const XeroConstant = {
    ClientID: "FDA2D813349A419789C8A97560EE935D",
    RedirectURL: `${xeroApi.defaults.baseURL}/callback`,
    Scope:[
    "offline_access",
    "openid",
    "profile",
    "email",
    "accounting.settings.read",
    "accounting.contacts.read",
    "accounting.attachments.read",
    "accounting.transactions.read"
  ].join(" "),
}